






















import { Tabbar, TabbarItem } from 'vant'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  }
})
export default class CommissionTabbar extends Vue {
  active = 'earn'

  tabbarBeforeChange(name: string) {
    switch (name) {
      case 'home':
        location.href = 'https://life.cekid.com/v2/rkhy/workbench?cmd=share&sharetype=0&refresh=no'
        break
      case 'share':
        location.href = 'https://life.cekid.com/v2/share-earn?showTabbar=1&cmd=share&sharetype=0&refresh=no'
        break
      case 'earn':
        break
      default:
        break
    }
    return false
  }
}
